class CoreHeaderNavController {
    constructor(shopperService) {
        this.shopperService = shopperService;
    }
}

const coreHeaderNavComponentDefinition = {
    bindings: {
        classModifier: '@?',
        onInspirationSelected: '&?',
        onRecipesSelected: '&?',
    },
    controller: ['ShopperService', CoreHeaderNavController],
    template: require('./core-header-nav.component.html').trim(),
};

module.exports = {
    CoreHeaderNavController,
    coreHeaderNavComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/core-header-nav.component.js